export enum SwitchToTask {
  SKIP = 'Skip',
  IN_MAIL = 'SwitchToInMail',
  STOP_AND_JUMP_TO_ANOTHER_STRATEGY = 'StopAndJumpToAnotherStrategy',

  //All above are obsolete, kept here for compatibility
  TO_EMAIL = 'SwitchToEmail',
  TO_CALL = 'SwitchToCall',
  DELAY = 'Delay',
}
